module.exports = __webpack_public_path__ + "static/media/image_93.ae078f6a.png";